import { SIMAElementClassifier, SIMARouteType, } from "@earthbrain/sima";
import { getNextRouteCoord, getPrevRouteCoord, interpolateSimpleCurve, } from "./route-utils";
/**
 * CenterLine (中心線形 / Route Type 3):
 * Defines the discrete station points (BP, No.0, No.1, SP, intermediate points, EP)
 * used for chainage and cross-sections.
 * In SIMA files, curves in CenterLine are delimited by C00 (Curve Begin) and C99 (Curve End)
 * containing the explicit B01 survey station points along the curve.
 */
export class CenterLine {
    group_number;
    route_number;
    route_name;
    route_type = SIMARouteType.CENTRAL_LINE;
    _points;
    constructor(route, surveyPoints, mainLine) {
        this.group_number = route.groupNumber;
        this.route_number = route.routeNumber;
        this.route_name = route.routeName;
        this._points = [];
        this._computeRoute(route, surveyPoints, mainLine);
    }
    setSurveyPoints(surveyPoints) {
        this._points = surveyPoints;
    }
    get points() {
        return this._points;
    }
    _computeRoute(route, surveyPoints, mainLine) {
        // If MainLine is present, it already computes and renders continuous geometric curve paths.
        // CentralLine only needs to extract the discrete station points (including those in C00..C99 curve blocks).
        if (mainLine) {
            this._points = route.routeElements
                .filter((r) => r.classifier === SIMAElementClassifier.ROUTE_COORD)
                .map((r) => {
                const rc = r;
                return surveyPoints.get(`${rc.point_number}-${rc.point_name}`);
            })
                .filter((pt) => pt !== undefined);
            return;
        }
        // When MainLine is not present, process route elements sequentially.
        // If C00..C99 contains intermediate survey points, they are used directly.
        // If a simple curve (C01) exists without intermediate C00..C99 points, compute geometric arc fallback.
        for (let i = 0; i < route.routeElements.length; i++) {
            const routeElement = route.routeElements[i];
            switch (routeElement.classifier) {
                case SIMAElementClassifier.ROUTE_COORD:
                    {
                        const rc = routeElement;
                        const point = surveyPoints.get(`${rc.point_number}-${rc.point_name}`);
                        if (point) {
                            this._points.push(point);
                        }
                    }
                    break;
                case SIMAElementClassifier.SIMPLE_CURVE:
                    {
                        const sc = routeElement;
                        const nextEl = route.routeElements[i + 1];
                        const hasIntermediateBlock = nextEl && nextEl.classifier === SIMAElementClassifier.CURVE_BEGIN;
                        // If no intermediate points block is provided, interpolate arc between endpoints
                        if (!hasIntermediateBlock) {
                            const prevPoint = getPrevRouteCoord(route.routeElements, i, surveyPoints);
                            const nextPoint = getNextRouteCoord(route.routeElements, i, surveyPoints);
                            if (prevPoint && nextPoint) {
                                const arcPoints = interpolateSimpleCurve(sc, prevPoint, nextPoint);
                                this._points.push(...arcPoints);
                            }
                        }
                    }
                    break;
                case SIMAElementClassifier.CURVE_BEGIN:
                case SIMAElementClassifier.CURVE_END:
                default:
                    break;
            }
        }
    }
}
//# sourceMappingURL=center-line.js.map